import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { addDays } from 'date-fns';
import { selectItemsAll, toggleItem } from 'utils/other';
import { DynamicOrder } from '../../utils/dynamic';
import { actionReportYieldExtremeFetch } from './actions';
import { IReportYieldExtremeItem, PREFIX } from './helpers';

export interface ReportYieldExtremeFilters {
  date: string;
  bonds: string[];
  issuers: string[];
  countryNames: string[];
  value: number[];
  bondMidroogRanks: string[];
  bondMidroogOutlooks: string[];
  bondMaalotRanks: string[];
  bondMaalotOutlooks: string[];
}

interface InitState {
  isInit: boolean;
  filters: ReportYieldExtremeFilters;
  data: Array<IReportYieldExtremeItem>;
  isLoading: boolean;
  isGroupByRating: boolean;
  symbols: number[];
  orderBy: DynamicOrder;
}

export const initState = (): InitState => {
  return {
    isInit: false,
    isLoading: false,
    isGroupByRating: false,
    data: [],
    filters: {
      // backend
      date: addDays(new Date(), -7).toISOString(),
      // frontend
      bonds: [],
      issuers: [],
      value: [6, 50],
      countryNames: [],
      bondMidroogRanks: [],
      bondMidroogOutlooks: [],
      bondMaalotRanks: [],
      bondMaalotOutlooks: [],
    },
    symbols: [],
    orderBy: {
      field: 'symbol',
      order: null,
    },
  };
};

const slice = createSlice({
  name: PREFIX,
  initialState: initState(),
  reducers: {
    setFilters(state, action: PayloadAction<ReportYieldExtremeFilters>) {
      state.filters =
        state.filters.date !== action.payload.date
          ? {
              ...initState().filters,
              date: action.payload.date,
            }
          : action.payload;
    },
    toggleItem(state, action: PayloadAction<{ id: string }>) {
      toggleItem(state.data, action.payload.id);
    },
    toggleAll(state, action: PayloadAction<{ value: boolean }>) {
      selectItemsAll(state.data, action.payload);
    },
    toggleGroupByRating(state) {
      state.isGroupByRating = !state.isGroupByRating;
    },
    applySymbols(state, action: PayloadAction<number[]>) {
      state.symbols = action.payload;
    },
    setOrder(state, action: PayloadAction<DynamicOrder>) {
      state.orderBy = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(actionReportYieldExtremeFetch.pending, (state, action) => {
        state.isLoading = true;
        state.isInit = true;
        if (action.meta.arg) {
          state.filters.date = action.meta.arg.initDate;
        }
      })
      .addCase(actionReportYieldExtremeFetch.fulfilled, (state, action) => {
        state.symbols = [];
        state.data = [];

        state.isLoading = false;
        action.payload.forEach((item) => {
          state.data.push({ ...item, __isSelected: true });
          state.symbols.push(item.symbol);
        });
      })
      .addCase(actionReportYieldExtremeFetch.rejected, (state, action) => {
        if (action.meta.aborted) {
          return state;
        }
        state.isLoading = false;
      });
  },
});
export const actionsReportYieldExtreme = slice.actions;
export const reducerReportYieldExtreme = slice.reducer;
